import { render, staticRenderFns } from "./SimpleForm.vue?vue&type=template&id=0205e614&scoped=true"
import script from "./SimpleForm.vue?vue&type=script&lang=js"
export * from "./SimpleForm.vue?vue&type=script&lang=js"
import style0 from "./SimpleForm.vue?vue&type=style&index=0&id=0205e614&prod&scoped=true&lang=scss"
import style1 from "./SimpleForm.vue?vue&type=style&index=1&id=0205e614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205e614",
  null
  
)

export default component.exports